export const gift = {
    gift_title: 'Your evolution',
    gift_points_1 : 'You have',
    gift_points_2 : 'points',
    gift_find_gift: 'Find my gift',
    milestone: "Milestone",
    milestone_passed: "The questionnaire's deadline has already passed.",
    milestone_available: "The questionnaire was available during this period.",
    milestone_soon: "This questionnaire will be available in {{count}} day{{plural}}.",
    milestone_reminder: "You will receive a reminder via {{methods}}.",
}